import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=12eab8cc&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=12eab8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eab8cc",
  null
  
)

export default component.exports